import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndTextArea from '../common/form/labelAndTextarea';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import { setError } from '../common/toast/toast';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import SelectDefault from '../common/form/selectDefault';
import DateFormat from '../common/dateFormat/DateFormat';
import ColorUtils from '../common/colorUtils/ColorUtils';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import ButtonTable from '../common/table/buttonTable';
import consts from '../consts';
import ListaAutoSuggestManual from '../common/form/ListaAutoSuggestManual';
import InputAssinatura from '../common/form/inputAssinatura';
import ConfirmModal from '../common/modal/confirmModal';

import {
	setModoTela, initForm, getListaManutencaoSugestoes, salvar,
	salvarEntrada
} from './controlePatioActions';
import ThSort from '../common/table/thSort';

class ControlePatioEntradaForm extends Component {

	state = {

	}

	componentWillMount() {
		this.props.getListaManutencaoSugestoes();
	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		const usuarioCCO = !!this.props.listaSetor.filter(item => item.id == 5 && ['GESTOR', 'SUPERVISOR', 'USUARIO'].includes(item.permissao)).length; //5 - CCO
		const usuarioRecepcao = !!this.props.listaSetor.filter(item => item.id == 7 && ['GESTOR', 'SUPERVISOR', 'USUARIO'].includes(item.permissao)).length; //7 - Recepção
	
		return (
			<>

				{this.state.confirmacao &&
				<ConfirmModal
					visible={this.state.confirmacao}
					titulo='Confirmação'
					mensagem={this.state.confirmacao.mensagem}
					textoConfirmar='Sim'
					textoCancelar='Cancelar'
					onConfirm={this.state.confirmacao.eventoSim}
					onCancel={this.state.confirmacao.eventoCancelar}
				/>}

				<ContentCard>
					<Form event={this.props.handleSubmit}>
						<ContentCardBody>
							<Row>
								<Field
									name='cavalo'
									options={this.props.listaCavalo}
									component={Select}
									label='Cavalo'
									cols='12 1 1 1'
									minWidth={165}
									placeholder='Selecione'
									readOnly={'readOnly'} />

								<Field
									name='carreta1'
									options={this.props.listaCarreta}
									component={Select}
									label='Carreta1'
									cols='12 1 1 1'
									minWidth={165}
									placeholder='Selecione'
									readOnly={this.props.formularioValues.registrosEntradaConfirmados || !usuarioRecepcao ? 'readOnly' : readOnly} />

								<Field
									name='carreta2'
									options={this.props.listaCarreta}
									component={Select}
									label='Carreta 2'
									cols='12 1 1 1'
									minWidth={165}
									placeholder='Selecione'
									readOnly={this.props.formularioValues.registrosEntradaConfirmados || !usuarioRecepcao ? 'readOnly' : readOnly} />
									
								<Field
									name='id_motorista'
									options={this.props.listaMotorista}
									component={Select}
									label='Motorista'
									cols='12 1 1 1'
									minWidth={300}
									placeholder='Selecione'
									readOnly={this.props.formularioValues.registrosEntradaConfirmados || !usuarioRecepcao ? 'readOnly' : readOnly} />

								<LabelAndInput
									name='datahora_previsao_entrada'
									component={LabelAndInput}
									label='Previsão de Chegada' placeholder='Informe'
									cols='12 1 1 1'
									minWidth={175}
									readOnly={'readOnly'}
									value={DateFormat.formatarDataHoraSqlParaTela(this.props.formularioValues.datahora_previsao_entrada)}
									onChange={() => { }} />

								<LabelAndInputDateTime
									label='Entrada'
									cols='12 1 1 1'
									readOnly={this.props.formularioValues.registrosEntradaConfirmados || !usuarioRecepcao ? 'readOnly' : readOnly}
									value={this.props.formularioValues.datahora_entrada}
									onChange={value => {
										this.props.initForm({
											...this.props.formularioValues,
											datahora_entrada: value
										});
									}} />

								<LabelAndInputDateTime
									label='Previsão de Saída'
									cols='8 1 1 1'
									readOnly={this.props.formularioValues.registrosEntradaConfirmados || !usuarioCCO ? 'readOnly' : readOnly}
									value={this.props.formularioValues.datahora_previsao_saida}
									onChange={value => {
										this.props.initForm({
											...this.props.formularioValues,
											datahora_previsao_saida: value
										});
									}} />
								
								<Grid cols='2 1 1 1'>
									<div style={{ width: 32, paddingTop: 24 }}>
										{/*<div class={`filter-chip ${this.props.formularioValues.previsao_viagem ? 'active' : ''}`}
											style={{
												margin: 1,
												borderRadius: 4,
												width: '100%',
												justifyContent: 'center'
											}}
											onClick={() => {
												this.props.initForm({
													...this.props.formularioValues,
													previsao_viagem: !this.props.formularioValues.previsao_viagem
												});	
											}}
											title='Previsão para a viagem'>
											<i class='fas fa-pallet'></i>
										</div>*/}
										<div class={`filter-chip ${this.props.formularioValues.previsao_cavalo ? 'active' : ''}`}
											style={{
												margin: 1,
												borderRadius: 4,
												width: '100%',
												justifyContent: 'center'
											}}
											onClick={() => {
												this.props.initForm({
													...this.props.formularioValues,
													previsao_cavalo: !this.props.formularioValues.previsao_cavalo
												});	
											}}
											title='Previsão para o cavalo'>
											<i class='fas fa-truck'></i>
										</div>
										<div class={`filter-chip ${this.props.formularioValues.previsao_carreta ? 'active' : ''}`}
											style={{
												margin: 1,
												borderRadius: 4,
												width: '100%',
												justifyContent: 'center'
											}}
											onClick={() => {
												this.props.initForm({
													...this.props.formularioValues,
													previsao_carreta: !this.props.formularioValues.previsao_carreta
												});	
											}}
											title='Previsão para a carreta'>
											<i class='fas fa-truck-loading'></i>
										</div>
									</div>
								</Grid>
							</Row>
							<Row>
								<Field
									name='shipping_entrada'
									component={LabelAndInput}
									label='Shipping Code' placeholder=''
									cols='12 1 1 1'
									minWidth={175}
									readOnly={'readOnly'} />
									
								<Field
									name='rumo_entrada'
									component={LabelAndInput}
									label='Rumo' placeholder=''
									cols='12 1 1 1'
									minWidth={175}
									readOnly={'readOnly'} />

								<Field
									name='cliente_entrada'
									component={LabelAndInput}
									label='Cliente' placeholder=''
									cols='12 1 1 1'
									minWidth={175}
									readOnly={'readOnly'} />

								<Field
									name='fronteira_entrada'
									component={LabelAndInput}
									label='Fronteira' placeholder=''
									cols='12 1 1 1'
									minWidth={175}
									readOnly={'readOnly'} />
								
								<Field
									name='destino_entrada'
									component={LabelAndInput}
									label='Destino' placeholder=''
									cols='12 1 1 1'
									minWidth={175}
									readOnly={'readOnly'} />

								<Field
									name='odometro_entrada'
									component={LabelAndInput}
									label='Odômetro' placeholder=''
									cols='12 1 1 1'
									minWidth={120}
									readOnly={this.props.formularioValues.registrosEntradaConfirmados || !usuarioRecepcao ? 'readOnly' : readOnly}
									casas={0} />

								<Grid cols='12 1 1 1' 
									style={{ 
										minWidth: (this.props.formularioValues.lote_crt_entrada ? 95 : 0)
											+ (this.props.formularioValues.carga_classificada_entrada ? 95 : 0) 
											+ (this.props.formularioValues.expresso_entrada ? 95 : 0)
									}}>
									<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
										{this.props.formularioValues.lote_crt_entrada &&
											<div
												style={{
													backgroundColor: '#1F3066',
													color: '#ffffff',
													paddingLeft: 4,
													paddingRight: 4,
													marginRight: 2,
													marginTop: 1,
													marginBottom: 1,
													borderRadius: 2,
													display: 'flex',
													flexDirection: 'column',
													width: 90,
													height: 67,
													justifyContent: 'center',
													alignItems: 'center',
													fontSize: 12
												}}
												title={this.props.formularioValues.lote_crt_entrada}>
												<i class='fas fa-boxes' style={{ fontSize: 18, marginBottom: 4 }}></i>
												Lote
											</div>}
										{this.props.formularioValues.carga_classificada_entrada &&
											<div
												style={{
													backgroundColor: '#1F3066',
													color: '#ffffff',
													paddingLeft: 4,
													paddingRight: 4,
													marginRight: 2,
													marginTop: 1,
													marginBottom: 1,
													borderRadius: 2,
													display: 'flex',
													flexDirection: 'column',
													width: 90,
													height: 67,
													justifyContent: 'center',
													alignItems: 'center',
													fontSize: 12
												}}>
												<i class='fas fa-exclamation-triangle' style={{ fontSize: 18, marginBottom: 4 }}></i>
												Classificada
											</div>}
										{this.props.formularioValues.expresso_entrada &&
											<div
												style={{
													backgroundColor: '#1F3066',
													color: '#ffffff',
													paddingLeft: 4,
													paddingRight: 4,
													marginRight: 2,
													marginTop: 1,
													marginBottom: 1,
													borderRadius: 2,
													display: 'flex',
													flexDirection: 'column',
													width: 90,
													height: 67,
													justifyContent: 'center',
													alignItems: 'center',
													fontSize: 12
												}}>
												<i class='fas fa-shipping-fast' style={{ fontSize: 18, marginBottom: 4 }}></i>
												Expressa
											</div>}
									</div>
								</Grid>
								
								{this.props.formularioValues.registrosEntradaConfirmados &&
								<Field
									name='observacao_entrada'
									component={LabelAndTextArea}
									label='Observação' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={this.props.formularioValues.registrosAguardandoEntrada ? 'readOnly' : readOnly} />}
							</Row>
							
							{(this.props.formularioValues.registrosEntradaConfirmados)
								? this.manutencao()
								: null
							}
							
							{this.props.formularioValues.registrosAguardandoEntrada
								? this.fichas()
								: null
							}

							{this.pendencias()}

							{this.props.formularioValues.registrosEntradaConfirmados &&
							<Row alignCenter>
								<Grid cols='12 12 8 8'>
									<p style={{ marginTop: 32, fontSize: 16 }}>
										Sr. Motorista, após chegar ao patio da matriz, o caminhão ficará inteiramente sob responsabilidade da equipe interna da empresa, tanto da manutenção, como dos manobristas. Sendo assim o motorista estará imediatamente em descanso, devendo retornar à empresa tão somente na hora prevista para saída do caminhão e (re)início de viagem.
									</p>
								</Grid>
								<Grid cols='12 12 12 12'>
									<Row alignCenter style={{ marginTop: 24 }}>
										<InputAssinatura
											idUploadAssinatura={`inputAssinatura_motorista`}
											label={`Assinatura do Motorista`}
											value={this.props.formularioValues.assinatura_motorista}
											semGaleria
											onChange={(assinatura) => {
												this.props.initForm({
													...this.props.formularioValues,
													assinatura_motorista_entrada: assinatura,
													termo_concordancia_entrada: 'Sr. Motorista, após chegar ao patio da matriz, o caminhão ficará inteiramente sob responsabilidade da equipe interna da empresa, tanto da manutenção, como dos manobristas. Sendo assim o motorista estará imediatamente em descanso, devendo retornar à empresa tão somente na hora prevista para saída do caminhão e (re)início de viagem.',
													datahora_assinatura_motorista_entrada: DateFormat.getDataHoraAtual()
												});
											}} />
									</Row>
								</Grid>
								<Grid cols='12 12 12 12' style={{ textAlign: 'center' }}>
									<label>{this.props.formularioValues.nome_motorista}</label>
								</Grid>
								{/*<Grid cols='12 12 12 12' style={{ textAlign: 'center', marginBottom: 24 }}>
									<p><b>CPF:</b> {this.props.formularioValues.cpf_motorista} | <b>CNH:</b> {this.props.formularioValues.cnh_motorista}</p>
								</Grid>*/}
							</Row>}

						</ContentCardBody>
						<ContentCardFooter>
							<Row alignCenter>
								{this.props.excluir ? (
									<Grid cols='6 6 4 3'>
										<Button
											text='Excluir'
											submit type={'danger'}
											icon={'fa fa-trash'} />
									</Grid>
								) : (
									<>
										{(!this.props.formularioValues.registrosEntradaConfirmados && usuarioCCO) &&
										<Grid cols='6 6 4 3'>
											<Button
												text='Alterar Previsão de Saída'
												type={'success'}
												icon={'fa fa-check'}
												event={() => {
													this.props.salvar({
														...this.props.formularioValues,
														datahora_entrada: null
													});
												}} />
										</Grid>}
											
										{(!this.props.formularioValues.registrosEntradaConfirmados && usuarioRecepcao) &&
										<Grid cols='6 6 4 3'>
											<Button
												text='Confirmar Dados de Entrada'
												type={'success'}
												icon={'fa fa-check'}
												event={() => {
													this.props.salvarEntrada({
														...this.props.formularioValues
													});
												}} />
										</Grid>}

										{(this.props.formularioValues.registrosEntradaConfirmados && !this.props.formularioValues.registrosAguardandoEntrada) &&
										<Grid cols='6 6 4 3'>
											<Button
												text='Salvar Informações'
												type={'success'}
												icon={'fa fa-check'}
												disabled={this.props.formularioValues.assinatura_motorista_entrada}
												event={() => {
													this.setState({
														confirmacao: {
															mensagem: 'Deseja realmente confirmar as informações de entrada no pátio?',
															eventoSim: () => {
																this.props.salvarEntrada({
																	...this.props.formularioValues
																});
																this.setState({
																	confirmacao: null
																});
															},
															eventoCancelar: () => {
																this.setState({
																	confirmacao: null
																});
															}
														}
													});
												}} />
											</Grid>}

										{this.props.formularioValues.registrosEntradaConfirmados &&
										<>
											{(usuarioRecepcao && !this.props.formularioValues.assinatura_motorista_entrada) &&
											<Grid cols='6 6 4 3'>
												<Button
													text='Desfazer Entrada no Pátio'
													type={'danger'}
													icon={'fa fa-check'}
													event={() => {
														this.setState({
															confirmacao: {
																mensagem: 'Deseja realmente desfazer a entrada no pátio?',
																eventoSim: () => {
																	this.props.salvar({
																		...this.props.formularioValues,
																		datahora_entrada: null
																	});
																	this.setState({
																		confirmacao: null
																	});
																},
																eventoCancelar: () => {
																	this.setState({
																		confirmacao: null
																	});
																}
															}
														});
													}} />
												</Grid>}
												<Grid cols='6 6 4 3'>
													<Button
														text='Confirmar Entrada no Pátio'
														type={'success'}
														icon={'fa fa-check'}
														disabled={!this.props.formularioValues.assinatura_motorista_entrada}
														event={() => {
															this.setState({
																confirmacao: {
																	mensagem: 'Deseja realmente realizar a entrada no pátio?',
																	eventoSim: () => {
																		this.props.salvarEntrada({
																			...this.props.formularioValues
																		});
																		this.setState({
																			confirmacao: null
																		});
																	},
																	eventoCancelar: () => {
																		this.setState({
																			confirmacao: null
																		});
																	}
																}
															});
														}} />
												</Grid>
											</>}
									</>
								)}
								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => this.props.setModoTela('lista')} />
								</Grid>
							</Row>
						</ContentCardFooter>
					</Form>
				</ContentCard>

				{this.listaLogs()}
			
			</>
		);
	}

	manutencao() {

		const lista = [{
			id_ficha: this.props.formularioValues.id_ficha_cavalo,
			placa: this.props.formularioValues.cavalo,
			tipo: 'Cavalo'
		}, {
			id_ficha: this.props.formularioValues.id_ficha_carreta1,
			placa: this.props.formularioValues.carreta1,
			tipo: 'Carreta 1'
		}, {
			id_ficha: this.props.formularioValues.id_ficha_carreta2,
			placa: this.props.formularioValues.carreta2,
			tipo: 'Carreta 2'
		}].filter(item => item.id_ficha);

		let sugestoes = this.props.listaManutencaoSugestoes.map(item => item.descricao);
		if (!this.props.formularioValues.listaTarefas) {
			this.props.initForm({
				...this.props.formularioValues,
				listaTarefas: (this.props.formularioValues.lista_manutencao || []).filter(manutencao => manutencao)
			})
		}
		(this.props.formularioValues.listaTarefas || []).forEach(item => {
			if (!sugestoes.includes(item.descricao)) {
				sugestoes.push(item.descricao);
			}
		});

		return (
			<>
				<Row>
					{lista.map(item => (
						<Grid cols='12 4 4 4' key={item.id_ficha}>
							<div class='card'>
								<div class='card-header'>
									<div class='d-flex justify-content-between'>
										<h3 class='card-title' style={{ fontWeight: 'bold' }}>{item.tipo}: {item.placa}</h3>
									</div>
								</div>
								<div class='card-body'>
									<ListaAutoSuggestManual
										opcoes={sugestoes}
										lista={this.props.formularioValues.listaTarefas ? this.props.formularioValues.listaTarefas.filter(tarefa => tarefa.id_controle_patio_ficha == item.id_ficha) : []}
										onChange={novaLista => {
											let listaTarefasAtual = (this.props.formularioValues.listaTarefas || []).filter(tarefa => tarefa.id_controle_patio_ficha != item.id_ficha).map(tarefa => ({ ...tarefa }));
											novaLista.forEach(tarefa => {
												listaTarefasAtual.push({
													...tarefa,
													id_controle_patio_ficha: item.id_ficha
												});
											});										

											this.props.initForm({
												...this.props.formularioValues,
												listaTarefas: listaTarefasAtual
											});
										}} />
								</div>
							</div>
						</Grid>
					))}
				</Row>
			</>
		)
	}

	manutencaoSalva() {

		const lista = [{
			id_ficha: this.props.formularioValues.id_ficha_cavalo,
			placa: this.props.formularioValues.cavalo,
			tipo: 'Cavalo'
		}, {
			id_ficha: this.props.formularioValues.id_ficha_carreta1,
			placa: this.props.formularioValues.carreta1,
			tipo: 'Carreta 1'
		}, {
			id_ficha: this.props.formularioValues.id_ficha_carreta2,
			placa: this.props.formularioValues.carreta2,
			tipo: 'Carreta 2'
		}].filter(item => item.id_ficha);

		return (
			<>
				<Row>
					{lista.map(item => {

						const manutencoes = (this.props.formularioValues.lista_manutencao || []).filter(manutencao => manutencao && manutencao.id_controle_patio_ficha == item.id_ficha);

						return (
							<Grid cols='12 4 4 4' key={item.id_ficha}>
								<div class='card'>
									<div class='card-header'>
										<div class='d-flex justify-content-between'>
											<h3 class='card-title' style={{ fontWeight: 'bold' }}>{item.tipo}: {item.placa}</h3>
										</div>
									</div>
									<div class='card-body'>
										{manutencoes.map((manutencao, pos) => (
											<Row key={manutencao.id}>
												<Grid cols='12 12 12 12'>
													<p>{pos + 1} - {manutencao.descricao}</p>
												</Grid>
											</Row>
										))}
									</div>
								</div>
							</Grid>
						);
					})}
				</Row>
			</>
		)
	}

	fichas() {

		return (
			<Row>
				<Grid cols='12 12 12 12'>
					<div class='card'>
						<div class='card-body'>
							<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap' }}>
								{(this.props.formularioValues.fichas_setores || []).map(ficha => {

									const fichaSelecionada = (this.state.registroFichas ? this.state.registroFichas.idsFichas || [] : []).includes(ficha.id_setor)
										|| (this.state.registroFichas ? this.state.registroFichas.idsFichas || [] : []).includes(ficha.id_setor_pai);

									let cor = null;
									if (ficha.quantidade == ficha.executadas) {
										cor = fichaSelecionada ? '#075e01' : '#087d00';
									} else if (ficha.obrigatoria) {
										cor = fichaSelecionada ? '#706f6f' : '#949191';
									} else {
										cor = fichaSelecionada ? '#706f6f' : '#949191';
									}

									return (
										<div className='controle-patio-button-hover'
											key={ficha.id_setor}
											style={{
												backgroundColor: cor,
												color: '#ffffff'
											}}
											onClick={() => {
												this.eventoFichas(ficha);
											}} >
											<i class={ficha.icone} style={{ marginRight: 4 }}></i>
											{ficha.nome}: {ficha.quantidade == ficha.executadas ? 'OK' : (`${ficha.executadas} de ${ficha.quantidade}`)}
										</div>
									);
								})}
							</div>
						</div>
						{this.registroFicha()}
					</div>
				</Grid>
			</Row>
		);
	}

	eventoFichas(ficha) {

		let idsFichas = this.state.registroFichas ? this.state.registroFichas.idsFichas || [] : [];
		if (idsFichas.includes(ficha.id_setor)) {
			idsFichas = idsFichas.filter(idAux => idAux != ficha.id_setor);
		} else {
			idsFichas.push(ficha.id_setor);
		}
		if (ficha.id_setor_pai) {
			if (idsFichas.includes(ficha.id_setor_pai)) {
				idsFichas = idsFichas.filter(idAux => idAux != ficha.id_setor_pai);
			} else {
				idsFichas.push(ficha.id_setor_pai);
			}
		}

		let listaPendencias = [];
		let listaFichas = [];

		if (idsFichas.includes(5) || idsFichas.includes(6) || idsFichas.includes(999)) {
			//Pendência
			listaPendencias = ([...this.props.formularioValues.listaPendenciaMotorista, ...this.props.formularioValues.listaPendenciaDemais]).map(pendencia => ({
				id: pendencia.id,
				nome_setor: pendencia.nome_setor,
				nome: pendencia.nome_motorista || pendencia.cavalo || pendencia.carreta || pendencia.shipping,
				nome_status: pendencia.nome_status,
				nome_tipo: pendencia.nome_tipo,
				observacao: pendencia.observacao,
				bloqueia_saida: pendencia.bloqueia_saida,
				data_maxima: pendencia.data_maxima,
				resolvida: pendencia.resolvida,
				cor: pendencia.resolvida ? '#087d00' : (
					pendencia.bloqueia_saida ? '#949191' : '#949191'
				)
			}))
		}
		if (idsFichas.filter(idAux => idAux != 5 && idAux != 6).length) {
			//Ficha
			listaFichas = (this.props.formularioValues.fichas_setores_completa || []).filter(itemFicha => itemFicha && idsFichas.includes(itemFicha.id_setor)).map(itemFicha => ({
				id: itemFicha.id,
				nome_setor: itemFicha.nome_setor,
				id_controle_patio_ficha: itemFicha.id_controle_patio_ficha,
				nome: ficha.nome_motorista || itemFicha.cavalo || itemFicha.carreta,
				datahora_fim: itemFicha.datahora_fim,
				datahora_inicio: itemFicha.datahora_inicio,
				datahora_liberacao: itemFicha.datahora_liberacao,
				obrigatoria: itemFicha.obrigatoria,
				cor: itemFicha.datahora_liberacao || itemFicha.datahora_fim ? '#087d00' : (
					itemFicha.obrigatoria ? '#949191' : '#949191'
				),
				lista_eventos: itemFicha.lista_eventos
			}))
		}

		if (this.state.registroFicha && this.state.registroFicha.id == ficha.id) {
			this.setFichas(null);
		} else {
			this.setFichas({
				idsFichas: idsFichas,
				nome: ficha.nome,
				listaPendencias: listaPendencias.length ? listaPendencias : null,
				listaFichas: listaFichas.length ? listaFichas : null,
				listaManutencoes: (this.props.formularioValues.lista_manutencao || []).filter(manutencao => manutencao)
			});
		}
	}
	

	pendencias() {

		if (!(this.props.formularioValues.listaPendencias || []).length) {
			return null;
		}

		return (
			<Row>
				{this.props.formularioValues.listaPendencias.map(item => (
					<Grid key={item.id} cols='12 6 4 4'>
						<div class={`alert ${item.obrigatoria ? 'alert-danger' : 'alert-warning'} alert-dismissible`}>
							<h5><i class={item.obrigatoria ? 'icon fas fa-ban' : 'icon fas fa-exclamation-triangle'}></i> {item.nome_setor}{item.obrigatoria ? ' (obrigatória)': ''}</h5>
							<p>{item.nome_tipo}</p>
							<p>{item.nome_tipo_ficha}: {item.nome_motorista || item.cavalo || item.carreta}</p>
						</div>
					</Grid>
				))}
			</Row>
		);
	}

	listaLogs() {

		if (!this.props.listaLog.length) {
			return null;
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<h3 class='card-title'>Logs</h3>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive border striped>
						<THead>
							<Tr backgroundColor={'#1F3066'}
								color={'#ffffff'}
								height={47}>								
								<ThSort field='datahora' label='Data/Hora' width={100} sticky />
								<ThSort field='operacao' label='Operação' width={100} sticky />
								<ThSort field='nome_status' label='Status' width={100} sticky />
								<ThSort field='cavalo' label='Cavalo' width={50} sticky />
								<ThSort field='carreta1' label='Carreta 1' width={50} sticky />
								<ThSort field='carreta2' label='Carreta 2' width={50} sticky />
								<ThSort field='nome_motorista' label='Motorista' width={200} sticky />
								<ThSort field='datahora_previsao_saida' label='Prev. Saída' width={100} sticky />
								<ThSort field='datahora_entrada' label='Entrada' width={100} sticky />
								<ThSort field='datahora_assinatura_motorista_entrada' label='Assinatura Entrada' width={100} sticky />								
								<ThSort field='datahora_saida' label='Saída' width={100} sticky />
								<ThSort field='datahora_assinatura_motorista_saida' label='Assinatura Saída' width={100} sticky />
								<ThSort field='nome_usuario' label='Usuário' width={200} sticky /> 
							</Tr>
						</THead>
						<TBody>
							{this.props.listaLog.map((item, i) => {
								return (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora)}</Td>
										<Td color={'#000'} alignCenter small>{item.operacao}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_status}</Td>
										<Td color={'#000'} alignCenter small>{item.cavalo}</Td>
										<Td color={'#000'} alignCenter small>{item.carreta1}</Td>
										<Td color={'#000'} alignCenter small>{item.carreta2}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_motorista}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrada)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_assinatura_motorista_entrada)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_assinatura_motorista_saida)}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_usuario}</Td>										
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	setFichas(registro) {
		this.setState({
			registroFichas: registro
		});
	}

	registroFicha() {

		if (!this.state.registroFichas) {
			return;
		}

		const registro = this.state.registroFichas;

		const possuiManutencao = registro.listaManutencoes.filter(manutencao => registro.idsFichas.includes(manutencao.id_setor)).length > 0;

		return (
			<Row>
				<Grid cols='12 12 12 12'>
					{registro.listaFichas &&
						<Table responsive border striped>
							<THead>
								<Tr backgroundColor={'#1F3066'} color={'#ffffff'} height={47}>
									<ThSort field='setor' label='Setor' width={100} sticky />
									<ThSort field='nome' label='Nome' width={100} sticky />
									{possuiManutencao &&
									<ThSort field='listaManutencoes' label='Itens' width={100} sticky />}
									<ThSort field='status' label='Status' width={100} sticky />
									<ThSort field='obrigatoria' label='Obrigatória' width={10} sticky />
									<ThSort field='lista_eventos' label='Histórico' width={10} sticky />
								</Tr>
							</THead>
							<TBody>
								{registro.listaFichas.map((item, i) => {
									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
											onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
											<Td color={'#000'} alignCenter>
												{item.nome_setor}
											</Td>
											<Td color={'#000'} alignCenter>{item.nome}</Td>
											{possuiManutencao &&
												<Td color={'#000'} alignCenter>
													<div>
														{registro.listaManutencoes.filter(manutencao => manutencao.id_controle_patio_ficha == item.id_controle_patio_ficha).map((manutencao, pos) => (
															<div key={pos} style={{ fontSize: 13, display: 'flex', alignItems: 'center' }}>

																<label
																	key={pos}
																	style={{
																		fontSize: 16,
																		display: 'flex',
																		alignItems: 'center',
																		padding: '8px 4px',
																		cursor: 'pointer',
																		userSelect: 'none'
																	}}
																	disabled={true}
																>
																	<input
																		type='checkbox'
																		checked={!!manutencao.executado}
																		style={{
																			marginRight: 10,
																			width: 18,
																			height: 18,
																			cursor: 'pointer'
																		}}
																		disabled={true}
																	/>

																	<span
																		style={{
																			textDecoration: !manutencao.executado ? 'line-through' : 'none',
																			color: !manutencao.executado ? '#888' : '#000',
																			fontSize: 14
																		}}
																	>
																		{manutencao.descricao}
																	</span>
																</label>

															</div>
														))}
													</div>
												</Td>}
											<Td color={'#000'} alignCenter>
												{item.datahora_fim ? 'Finalizada' : (item.datahora_liberacao ? 'Liberada' : (item.datahora_inicio ? 'Iniciada' : 'Não Inciada'))}
											</Td>
											<Td color={'#000'} alignCenter>{item.obrigatoria ? 'Sim' : 'Não'}</Td>
											<Td color={'#000'} alignCenter>
												<table style={{ width: '100%' }}>
													<tbody>
														{(item.lista_eventos || []).map(itemEvento => (
															<tr key={itemEvento.id}>
																<td width={100} style={{ fontSize: 10, textAlign: 'center', verticalAlign: 'middle' }}>{itemEvento.nome_evento}</td>
																<td width={100} style={{ fontSize: 10, textAlign: 'center', verticalAlign: 'middle' }}>{DateFormat.formatarDataHoraSqlParaTela(itemEvento.datahora)}</td>
																<td width={200} style={{ fontSize: 10, textAlign: 'center', verticalAlign: 'middle' }}>{itemEvento.nome_usuario}</td>
															</tr>
														))}
													</tbody>
												</table>
											</Td>
										</Tr>
									);
								})}
							</TBody>
						</Table>}

					{registro.listaPendencias &&
						<Table responsive border striped>
							<THead>
								<Tr backgroundColor={'#1F3066'} color={'#ffffff'} height={47}>
									<ThSort field='setor' label='Setor' width={100} sticky />
									<ThSort field='nome' label='Nome' width={100} sticky />
									<ThSort field='nome_status' label='Status' width={100} sticky />
									<ThSort field='nome_tipo' label='Pendência' width={100} sticky />
									<ThSort field='observacao' label='Observação' width={100} sticky />
									<ThSort field='obrigatoria' label='Obrigatória' width={10} sticky />
									<ThSort field='data_maxima' label='Data Máxima' width={100} sticky />
								</Tr>
							</THead>
							<TBody>
								{registro.listaPendencias.map((item, i) => {
									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
											onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
											<Td color={'#000'} alignCenter>
												{item.nome_setor}
											</Td>
											<Td color={'#000'} alignCenter>{item.nome}</Td>
											<Td color={'#000'} alignCenter>{item.nome_status}</Td>
											<Td color={'#000'} alignCenter>{item.nome_tipo}</Td>
											<Td color={'#000'} alignCenter>{item.observacao}</Td>
											<Td color={'#000'} alignCenter>{item.obrigatoria ? 'Sim' : 'Não'}</Td>
											<Td color={'#000'} alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_maxima)}</Td>
										</Tr>
									);
								})}
							</TBody>
						</Table>}
				</Grid>
			</Row >
		);
	}

}

ControlePatioEntradaForm = reduxForm({ form: 'controlePatioForm', destroyOnUnmount: false })(ControlePatioEntradaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('controlePatioForm')(state),
	registro: state.controlePatio.registro,
	listaMotorista: state.controlePatio.listaMotorista,
	listaCavalo: state.controlePatio.listaCavalo,
	listaCarreta: state.controlePatio.listaCarreta,
	listaManutencaoSugestoes: state.controlePatio.listaManutencaoSugestoes,
	listaSetor: state.setor.listaSelect.filter(item => {
		return (item.ids_usuarios || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_supervisores || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_gestores || []).includes(state.auth.usuario.id);
	}).map(item => ({
		...item,
		permissao: (item.ids_usuarios_gestores || []).includes(state.auth.usuario.id) ? 'GESTOR' : (
			(item.ids_usuarios_supervisores || []).includes(state.auth.usuario.id) ? 'SUPERVISOR' : (
				(item.ids_usuarios || []).includes(state.auth.usuario.id) ? 'USUARIO' 
				: 'SEM PERMISSAO'
			)
		)
	})),
	listaLog: state.controlePatio.listaLog
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, getListaManutencaoSugestoes, salvar,
	salvarEntrada
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControlePatioEntradaForm);